export default "__VITE_ASSET__ydc4V3ew__"